import React from "react";
import {
  EpDevPUtils,
  IEpDevPManagedAssetIndexableDocument,
  TEpDevPEntityId,
} from "@solace-labs/backstage-plugin-ep-devp-common";
import { EpDevPSearchFilterSelect } from "../EpDevPSearchFilters";
import { useServiceRegistryTranslation } from '../../../../../i18n/ServiceRegistryLanguageProvider';

/** @alpha */
export type EpDevPSearchFilterDomainsProps = {
  domains: Array<TEpDevPEntityId>;
  className?: string;
}

/** @alpha */
export const EpDevPSearchFilterDomains = (props: EpDevPSearchFilterDomainsProps) => {
  const { t } = useServiceRegistryTranslation();

  const SearchFieldName = "epDevPManagedAsset.epDevPDomainInfo.owningDomainEntityId.displayName" as const;
  const { domains, className } = props;
  return (
    <EpDevPSearchFilterSelect
      className={className}
      title={t('developerSearch.domains')}
      searchFieldName={EpDevPUtils.nameOf<IEpDevPManagedAssetIndexableDocument>(SearchFieldName)}
      valuesEntityIdList={domains}
    />
  );
}
